/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import RenewalsRowQuotes from '../components/RenewalsRowQuotes'
import RenewalsRowPolicies from '../components/RenewalsRowPolicies'
import VariationsDropdown from '../components/VariationsDropdown'

/**
 * RenewalsTable class which will contain all the rows of the Quotes and Policies
 *
 * @export
 * @class RenewalsTable
 * @extends {React.Component<any, any>}
 */
export default class RenewalssTable extends React.Component<any, any> {

    /**
     * Creates an instance of RenewalsTable.
     * @param {*} props
     * @memberof RenewalsTable
     */
    constructor(props: any) {
        super(props)
        this.state = {
            quotes: [],
            policies: [],
            noOverflow: false,
        }
    }

    /**
     * Will update the parent's data before the component mounts
     *
     * @memberof RenewalsTable
     */
    componentWillMount() {
        if (this.props.updateData) {
            this.props.updateData('Quotes', this.state.quotes)
            this.props.updateData('Policies', this.state.policies)
        }
        if (this.props.renewalsList) {
            switch (this.props.dataType) {
                case 'inReferral':
                case 'invitedRenewals':
                    this.setState(
                        {
                            quotes: this.props.renewalsList,
                        }
                    )
                    break

                case 'futureRenewals':
                    this.setState(
                        {
                            policies: this.props.renewalsList,
                        }
                    )
                    break

                default:
                    break
            }
        }
    }

    componentWillUpdate(nextProps: any) {
        if (nextProps !== this.props) {
            if (nextProps.renewalsList) {
                switch (nextProps.dataType) {
                    case 'inReferral':
                    case 'invitedRenewals':
                        this.setState(
                            {
                                quotes: nextProps.renewalsList,
                            }
                        )
                        break

                    case 'futureRenewals':
                        this.setState(
                            {
                                policies: nextProps.renewalsList,
                            }
                        )
                        break

                    default:
                        break
                }
            }
        }
    }
    /**
     * Will open or close the item of the row
     *
     * @memberof RenewalsTable
     * @param element the element selected
     */
    openCloseItem = (element) => {
        if (element.target.classList.contains('column__dropdown')) {
            if (element.target.classList.contains('active')) {
                element.target.parentNode.classList.remove('active')
                element.target.parentNode.nextSibling.classList.remove('active')
                element.target.classList.remove('active')
            } else if (element.target.classList.contains('column__dropdown')) {
                element.target.parentNode.classList.add('active')
                element.target.parentNode.nextSibling.classList.add('active')
                element.target.classList.add('active')
            }
        }
    }

    /**
     * Will show the edit quote PopUp
     *
     * @memberof RenewalsTable
     */
    viewQuoteClick = () => {
        this.setState({ viewQuotePopUp: !this.state.viewQuotePopUp })
    }

    render() {
        return (
            <div>
                {(this.props.dataType !== 'futureRenewals' && this.state.quotes) ?
                    (this.state.quotes.map((quote: any, i: number) => (
                        <div key={i} className={`quoteListRow ${this.state.noOverflow ? 'noOverflow' : ''}`}>
                            <RenewalsRowQuotes
                                {...this.props}
                                quote={quote}
                                action={this.openCloseItem}
                                openPopUp={this.viewQuoteClick}
                                referralType={this.props.referralType}
                                // showRenewPolicyPopUp={this.props.showRenewPolicyPopUp}
                            />
                            <VariationsDropdown
                                quote={quote}
                                renewAsIs={this.props.renewAsIs}
                                fecthRenewAsIs={(policyId) => this.props.fecthRenewAsIs(policyId)}
                                fecthRenewPolicy={(policyId) => this.props.fecthRenewPolicy(policyId)}
                                variations={quote.renewalQuotes}
                                referralType={this.props.referralType}
                                pendingReferral={this.props.referralType === 'inReferral'}
                                noOverflow={(state) => this.setState({ noOverflow: state })}
                                history={this.props.history}
                            />
                        </div>
                    )
                    )) :
                    (
                        (this.state.policies) ?
                            (this.state.policies.map((policy: any, i: number) => (
                                <div key={i} className="policiesListRow">
                                    <RenewalsRowPolicies
                                        quote={policy}
                                        // action={this.openCloseItem}
                                        // manageAgency={this.props.manageAgency}
                                        // showRenewPolicyPopUp={this.props.showRenewPolicyPopUp}
                                        showRenewPolicyPopUp={this.props.showRenewPolicyPopUp}
                                        showLapseRenewPopUp={this.props.showLapseRenewPopUp}
                                    />
                                </div>
                            ))
                            ) : null
                    )
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Renewals/components/RenewalsTable.tsx